import React, {useContext} from 'react'
import { AppBar, Toolbar, Button, IconButton } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout';
import { Context } from '../App';

export default function Header(props) {
    const { updateConnect } = useContext(Context)

    function handleLogout() {
        sessionStorage.clear()
        updateConnect(false)
    }

    return(
        <AppBar position='sticky'>
            <Toolbar sx={{display:'flex', justifyContent:'space-between'}}>
                <Button color='inherit' variant="text" href='/'>AGO2025</Button>
                <IconButton
                color='inherit'
                onClick={handleLogout}>
                    <LogoutIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}